import {
  DesktopLayoutBoxed,
  DesktopLayoutBoxedContent,
} from '@kanda-libs/ks-design-library';

import { Content } from '../components';

interface ViewComponentProps {
  /**
   * Disabled state
   */
  disabled?: boolean;
  /**
   * Function to sign in with Google
   */
  signInWithGoogle?: () => unknown;
}

const ViewComponent = ({ ...props }: ViewComponentProps) => (
  <DesktopLayoutBoxed>
    <DesktopLayoutBoxedContent>
      <Content {...props} />
    </DesktopLayoutBoxedContent>
  </DesktopLayoutBoxed>
);

ViewComponent.displayName = 'StaffLogin-Desktop-view';

ViewComponent.defaultProps = {
  disabled: false,
  signInWithGoogle: undefined,
};

export default ViewComponent;
